import { c as _c } from "react/compiler-runtime";
import type { ManagedControl } from '@onefootprint/request-types/dashboard';
import { Checkbox, MultiSelect, Select } from '@onefootprint/ui';
import { useBuilder } from '../../store/provider';
import type { ManagedNode } from '../../store/types';
import { getPath, setPath } from './config-path';
type ControlRendererProps = {
  node: ManagedNode;
  control: ManagedControl;
};

// One Control bound to the node's config by its dotted path.
const ControlRenderer = t0 => {
  const $ = _c(27);
  const {
    node,
    control
  } = t0;
  const {
    actions,
    isReadOnly
  } = useBuilder();
  let t1;
  if ($[0] !== actions || $[1] !== control.path || $[2] !== isReadOnly || $[3] !== node) {
    t1 = value => {
      if (isReadOnly) {
        return;
      }
      actions.updateManagedConfig(node, setPath(node.config, control.path, value));
    };
    $[0] = actions;
    $[1] = control.path;
    $[2] = isReadOnly;
    $[3] = node;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const write = t1;
  let t2;
  if ($[5] !== control.default || $[6] !== control.kind || $[7] !== control.label || $[8] !== control.minSelected || $[9] !== control.options || $[10] !== control.path || $[11] !== isReadOnly || $[12] !== node.config || $[13] !== node.id || $[14] !== write) {
    t2 = () => {
      if (control.kind === "checkbox") {
        const checked = getPath(node.config, control.path) as boolean | undefined ?? control.default;
        return <Checkbox checked={checked} label={control.label} disabled={isReadOnly} onChange={e => write(e.target.checked)} />;
      }
      if (control.kind === "multi_select") {
        const selected = getPath(node.config, control.path) as string[] | undefined ?? control.default;
        const isBelowMinimum = selected.length < control.minSelected;
        return <MultiSelect hideSelectAll={true} disabled={isReadOnly} value={selected} options={control.options} hasError={isBelowMinimum} errorMessage={isBelowMinimum ? `Select at least ${control.minSelected}` : undefined} onChange={next => write(next)} />;
      }
      const value_0 = getPath(node.config, control.path) as string | undefined ?? control.default;
      return <Select id={`managed-${node.id}-${control.path}`} aria-label={control.label} size="compact" disabled={isReadOnly} value={value_0} options={control.options} onChange={next_0 => write(next_0)} />;
    };
    $[5] = control.default;
    $[6] = control.kind;
    $[7] = control.label;
    $[8] = control.minSelected;
    $[9] = control.options;
    $[10] = control.path;
    $[11] = isReadOnly;
    $[12] = node.config;
    $[13] = node.id;
    $[14] = write;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  const input = t2;
  let t3;
  if ($[16] !== control.kind || $[17] !== control.label) {
    t3 = control.kind !== "checkbox" && <span className="text-caption-3 font-medium text-tertiary">{control.label}</span>;
    $[16] = control.kind;
    $[17] = control.label;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== input) {
    t4 = input();
    $[19] = input;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== control.description) {
    t5 = control.description && <span className="text-caption-3 text-tertiary">{control.description}</span>;
    $[21] = control.description;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t3 || $[24] !== t4 || $[25] !== t5) {
    t6 = <div className="flex flex-col gap-1">{t3}{t4}{t5}</div>;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
};
export default ControlRenderer;